import Swiper from 'swiper';
import SwiperCore, { Navigation, Scrollbar } from 'swiper/core';
import 'swiper/css';
SwiperCore.use([Navigation, Scrollbar]);
import debounce from 'lodash/debounce';

export default class PortraitVideoSwiper {
    /**
        * Class constructor *
        * @arg {object} - `sliderElement` check for the
        * featured Collections slider element.
    **/
    constructor (sliderElement) {
        if (!sliderElement) return;

        this.swiperInit = false
        this.sliderElement = sliderElement;
        this.sliderWrapper = this.sliderElement.querySelector('.js-swiper-wrapper');
        this.sliderSlides = this.sliderElement.querySelectorAll('.js-swiper-slide');
        this.arrowNext = this.sliderElement.querySelector('.swiper-button-next');
        this.arrowPrev = this.sliderElement.querySelector('.swiper-button-prev');
        this.scrollbar = this.sliderElement.querySelector('.swiper-scrollbar');
        this.swiperNav = this.sliderElement.querySelector('.js-swiper-nav');

        this.handleSwiperInit();

        const debouncedSwiperInit = debounce(() => {
            this.handleSwiperInit();
        }, 100);

        window.addEventListener('resize', () => {
            debouncedSwiperInit();
        });
    }

    handleSwiperInit () {
        if(window.innerWidth <= 1023 && this.sliderSlides.length >= 2)  {
            this.swiper = new Swiper(this.sliderElement, {
                slidesPerView: 1.1,
                spaceBetween: 20,
                threshold: 10,
                center: true,
                init: false,
                navigation: {
                    nextEl: this.arrowNext,
                    prevEl: this.arrowPrev
                },
                scrollbar: {
                    el: this.scrollbar,
                    draggable: true,
                    hide: false
                },
                breakpoints: {
                    768: {
                        slidesPerView: 2.2,
                    },
                    1024: {
                        slidesPerView: 4,
                    }
                }
            });

            this.sliderElement.classList.add('swiper');
            this.sliderWrapper.classList.add('swiper-wrapper');
            this.sliderSlides.forEach(slide => {
                slide.classList.add('swiper-slide');
            });
            this.swiperNav.classList.remove('hidden');
            this.swiperNav.classList.add('flex');
            this.swiper.init();
            this.swiperInit = true
        } else {
            this.sliderElement.classList.remove('swiper');
            this.sliderWrapper.classList.remove('swiper-wrapper');
            this.swiperNav.classList.add('hidden');
            this.swiperNav.classList.remove('flex');
            this.sliderSlides.forEach(slide => {
                slide.classList.remove('swiper-slide');
            });

            if (this.swiperInit) {
                this.swiper.destroy(false, true);
                this.swiperInit = false
            }
        }
    }
}
